export function useOrientationVideo() {
    const isPortrait = ref(false)

    onMounted(() => {
        const mq = window.matchMedia('(orientation: portrait)')
        isPortrait.value = mq.matches

        mq.addEventListener('change', (e) => {
            isPortrait.value = e.matches
        })

        onUnmounted(() => mq.removeEventListener('change', () => {}))
    })

    return { isPortrait }
}